import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import rehypeAutolinkHeadings from "rehype-autolink-headings";
import { Link } from "react-router-dom";
import { CodeBlock } from "./CodeBlock";

type Props = {
  content: string;
};

/**
 * Headless blog renderer: GFM tables, slugged headings, internal /links use React Router.
 */
export function BlogMarkdown({ content }: Props) {
  return (
    <article className="prose prose-invert prose-headings:font-display prose-a:text-signal-sky max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSlug, [rehypeAutolinkHeadings, { behavior: "wrap" }]]}
        components={{
          pre: ({ children }) => <>{children}</>,
          a: ({ href, children, ...rest }) => {
            if (href?.startsWith("/")) {
              return (
                <Link to={href} {...rest}>
                  {children}
                </Link>
              );
            }
            return (
              <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
                {children}
              </a>
            );
          },
          code: ({ className, children, ...props }) => {
            const inline = !className;
            if (inline) {
              return (
                <code className="rounded bg-white/10 px-1.5 py-0.5 text-sm text-signal-amber" {...props}>
                  {children}
                </code>
              );
            }
            return (
              <CodeBlock className={className}>
                {children}
              </CodeBlock>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </article>
  );
}
